import { ref } from 'vue';
import productService from '@/services/productService';

export function useProducts(axios) {
  const products = ref([]);
  const currentPage = ref();
  const totalPages = ref();
  const loading = ref(true);
  const error = ref(null);
  const product1 = ref({});

  const fetchProductDetails = async (id) => {
    loading.value = true; // Set loading to true
    try {
      const { data } = await productService(axios).getProduct(1, id); // Assuming page=1
      product1.value = data.product;
      return data;
      // return product.value; // Return the actual product data
    } catch (err) {
      error.value = 'Failed to load product details';
      console.error('Error fetching product details:', err);
    } finally {
      loading.value = false;
    }
  };
  const fetchProducts = async (page = '',sortby,category,brands,limit,sponsor='False',search='') => {
    try {
      const { data } = await productService(axios).getProducts(page,sortby,category,brands,limit,sponsor,search);
      console.log(data);
      products.value = data.products;
      currentPage.value = data.current_page;
      totalPages.value = data.total_pages;
    } catch (err) {
      error.value = 'Failed to load products';
    } finally {
      loading.value = false;
    }
  };
  const fetchProductsByCategory = async (category,limit,sortby) => {
    try {
      const { data } = await productService(axios).getProductsByCategory(category,limit,sortby);
      // console.log(category,limit,sortby)
      console.log(data);
      products.value = data.products;
      currentPage.value = data.current_page;
      totalPages.value = data.total_pages;
    } catch (err) {
      error.value = 'Failed to load products';
    } finally {
      loading.value = false;
    }
  };
  const fetchProductsByCategorySlug = async (slug,limit,sortby) => {
    try {
      const { data } = await productService(axios).getProductsByCategorySlug(slug,limit,sortby);
      // console.log(data)
      products.value = data.products;
      currentPage.value = data.current_page;
      totalPages.value = data.total_pages;
    } catch (err) {
      error.value = 'Failed to load products';
    } finally {
      loading.value = false;
    }
  };


  const searchProducts = async(query, limit) => {
    try{
      const response = await productService(axios).getsearchProducts(query, limit);
      console.log("responseresponseresponse", response)
     return response;
    }catch (err) {
      error.value = 'Error in search products';
    } finally {
      loading.value = false;
    }
  }

 

  return {
    products,
    loading,
    error,
    currentPage,
    totalPages,
    // product,
    fetchProducts,
    fetchProductDetails,
    fetchProductsByCategory,
    fetchProductsByCategorySlug,
    searchProducts
  };
}
// export function useProduct(axios) {
//   const product = ref({});
//   const loading = ref(true);
//   const error = ref(null);

//   const fetchProduct = async (page = 1,id) => {
//     try {
//       const { data } = await productService(axios).getProduct(page,id);
//       // console.log(data)
//       product.value = data;
//     } catch (err) {
//       error.value = 'Failed to load product';
//     } finally {
//       loading.value = false;
//     }
//   };

//   return {
//     product,
//     loading,
//     error,
//     fetchProduct,
//   };
// }
